const template = require('./filter_range.html.slim');
declare var angular
import { merge } from 'lodash'

export class FilterRange {
  static $inject = ['$rootScope', '$location', '$timeout']

  query: string

  private _rangeTo: string = null
  private _rangeFrom: string = null

  constructor(private $rootScope, private $location, private $timeout) {
    this.setRangeValuesFromQuery()

    $rootScope.$on('deselectFilterTriggered', (() => {
      this.clearFilter()
    }));

    $rootScope.$on('$routeUpdate', (() => {
      this.setRangeValuesFromQuery()
    }));
  }

  get rangeTo(): string { return this._rangeTo; }
  set rangeTo(value) {
    this.updateFilter(value, this.query + 'To')
    this._rangeTo = value
  }

  get rangeFrom(): string { return this._rangeFrom }
  set rangeFrom(value) {
    this.updateFilter(value, this.query + 'From')
    this._rangeFrom = value
  }

  public isFiltered(): boolean { return !!(this.rangeFrom || this.rangeTo); }

  public clearFilter(): void {
    this.rangeTo = null
    this.rangeFrom = null
  }

  public closeTooltip(el): void {
    this.$timeout(function() {
      angular.element(el).find('.filter-range-label').click()
    })
  }

  private updateFilter(queryValue: string, queryName: string) {
    var query: Object = {}
    query[queryName] = queryValue
    this.$location.search()[queryName] = null
    this.$location.replace().search(merge(this.$location.search(), query))
  }

  private setRangeValuesFromQuery(): void {
    let rangeFrom = this.$location.search()[this.query + "From"]
    let rangeTo = this.$location.search()[this.query + "To"]
    if (rangeFrom) { this._rangeFrom = rangeFrom }
    if (rangeTo) { this._rangeTo = rangeTo }
  }
}

angular.module('wbComponents').directive('wbFilterRange', function() {
  return {
    restrict: 'E',
    controller: FilterRange,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      query: '@',
      type: '@'
    },
    templateUrl: template,
  };
});
